var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.mapa)?_c('section',{staticClass:"wrapper-bloque bloque-mapa",attrs:{"id":_vm.id}},[_c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":"AIzaSyCFeOF9zk0hFIYuMhmawwGAAsST4d3LtUE","sedes":_vm.content.datos.sedes}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }